<a class="text-logo-blue d-block text-center" *ngIf="this.csvURL" (click)="download()">
    <i class="fas fa-download" aria-hidden="true"></i>
</a>
<span *ngIf="!this.csvURL">{{"not_available" | translate}}</span>